import { stripLanguagePrefix } from "./stripLanguagePrefix";

type ShouldBlockPathChangeNavigationParams = {
  skipUnsavedChangesPrompt: boolean;
  hasUnsavedChanges: boolean;
  isSubmitting?: boolean;
  currentPathname: string;
  nextPathname: string;
};

const shouldBlockPathChangeNavigation = ({
  skipUnsavedChangesPrompt,
  hasUnsavedChanges,
  isSubmitting = false,
  currentPathname,
  nextPathname,
}: ShouldBlockPathChangeNavigationParams) => {
  if (skipUnsavedChangesPrompt) {
    return false;
  }
  if (isSubmitting) {
    return false;
  }
  if (!hasUnsavedChanges) {
    return false;
  }

  const currentPath = stripLanguagePrefix(currentPathname);
  const nextPath = stripLanguagePrefix(nextPathname);

  return currentPath !== nextPath;
};

export default shouldBlockPathChangeNavigation;
